// Browser download helper: object URL -> temp <a download> click -> revoke.
// Shared by report.js and shareCard.js; Node-side rendering (sample script)
// writes files directly instead.

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
